<template>
  <div class="page-wrapper">
    <component v-bind:is="headerComponent"></component>
    <div class="content">
      <div class="container">
        <div class="content__aside">
          <component v-bind:is="sidebarComponent"></component>
        </div>
        <div class="content__main">
          <component name="billing-support" v-bind:is="articlesComponent"></component>
        </div>
      </div>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent, trackPageView } from '@/utils/common';

export default {
  name: 'billing_support',
  created() {
    trackPageView('billing_support');
  },
  computed: {
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    sidebarComponent() {
      return getComponent(this.$store.getters.flowObject, 'sidebar');
    },
    articlesComponent() {
      return getComponent(this.$store.getters.flowObject, 'articles');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/zeus-design.scss';
</style>
